export default "__VITE_ASSET__6fa32881__"